import React, { useContext, useEffect, useState } from "react";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { CurrentBlogData } from "../../ApiServices/BlogApi/BlogAPI";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import MobileAppAd from "../../Components/MoblieAddComponent";
import { Helmet } from "react-helmet-async";

const Blogs = () => {
  const userID = localStorage.getItem("userID") || "";
  const { slug } = useParams();
  const [currentBlog, setCurrentBlog] = useState([]);
  const [blogList, setblogList] = useState([]);
  const [searchKeyWord, setSearchKeyword] = useState("");
  const location = useLocation();

  const { setLoader } = useContext(LoaderContext);
  const navigate = useNavigate();



  // useEffect(() => {
  //   debugger;
  //   if (location.state.currentBlog) {
  //     setCurrentBlog(location.state.currentBlog);
  //   }
  // }, [location?.state]);

  useEffect(() => {
    GetCurrentBlog({
      START: 0,
      END: 100,
      WORD: "",
      EXTRA1: "",
      EXTRA2: "",
      EXTRA3: "",
      LANG_ID: "1",
      USER_ID: localStorage.getItem("userID"),
    });
  }, []);

  const GetCurrentBlog = async (params) => {
    // debugger;
    setLoader(true);

    const response = await CurrentBlogData(params);

    if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
      setLoader(false);
      const blogs = response?.DATA;
      const current = blogs.find((item) => item.Blog_Slug?.trim() === slug?.trim());
      const otherBlogs = blogs
        .filter((item) => item.Blog_Slug?.trim() !== slug?.trim())
        .slice(0, 10); // Take only first 10 excluding current

      setCurrentBlog(current);
      setblogList(otherBlogs);
      //   if (blogs.length > 0) {
      //     if (location.state) {
      //       setCurrentBlog(location.state.blog);
      //     } else {
      //       setCurrentBlog(blogs[0]); // Set the first blog as the current blog
      //     }
      //   }
    }
  };

  const filteredBlogs = blogList.filter(
    (data) =>
      data.BLOG_TITLE.toLowerCase().includes(searchKeyWord.toLowerCase()) &&
      data.BLOG_TITLE !== currentBlog?.BLOG_TITLE
  );

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };

  console.log('currentBlog', currentBlog)
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": currentBlog?.META_Title,
    "description": currentBlog?.META_DESCRIPTION,
    "image": currentBlog?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": currentBlog?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": currentBlog?.canonicalURL
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": currentBlog?.META_Title,
    "description": currentBlog?.META_DESCRIPTION,
    "url": currentBlog?.canonicalURL,
    "image": currentBlog?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/spiritual-gyan/${currentBlog?.Blog_Slug}`
    }
  };

  const breadcrumbSchema =
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Spiritual Gyan",
        "item": "https://www.myomnamo.com/spiritual-gyan/"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": currentBlog?.META_Title,
        "item": currentBlog?.CanonicalTag
      }
    ]
  }


  return (
    <>
      <section className="page-header" style={{ marginBottom: "2rem" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <p className="page-header__title bw-split-in-left">
            Spiritual Gyan
          </p>
        </div>
      </section>
      <Helmet>
        {/* Meta Title & Description */}
        <title>{currentBlog?.META_Title}</title>


        <link rel="canonical" href={currentBlog?.CanonicalTag} />
        {/* Meta description */}
        <meta name="description" content={currentBlog?.META_DESCRIPTION} />
        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>



      </Helmet>
      <div
        className="container"
        style={{ display: "felx", flexDirection: "column" }}
      >
        <div
          className="row title"
          style={{
            marginBottom: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className="col-8">
            {/* <span
              style={{
                fontSize: "22px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                width: "auto",
              }}
            >
              Recent Posts
            </span> */}
          </div>
          <div className="col-4" style={{ padding: "0" }}>
            {/* Search Bar */}
            <div
              className="search-box"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "1",
                maxWidth: "100%",
                // marginRight: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                className=" custom-search-input"
                value={searchKeyWord}
                onChange={(e) => setSearchKeyword(e.target.value)}
              // style={{
              //   width: "100%",
              //   minWidth: "100px",
              //   padding: "8px",
              //   borderRadius: "5px",
              // }}
              />
              {/* <FaSearch className="position-absolute top-50 end-0 me-3 translate-middle-y text-warning" /> */}
            </div>
          </div>
        </div>

        <div className="row">
          {/* Current Blog Section */}
          {currentBlog && (
            <div
              // style={{ cursor: "pointer" }}
              className="col-lg-8 col-md-5 col-sm-12"
            // onClick={() =>
            //   navigate("/blog-post", {
            //     state: {
            //       currentBlog: currentBlog,
            //       filteredBlogs: filteredBlogs,
            //     },
            //   })
            // }
            >
              <div className=" zoom-effect" style={{ width: '97%' }}>
                <img
                  src={currentBlog.BLOG_IMAGE}
                  alt={currentBlog.BLOG_TITLE}
                  className="blog-img"
                  style={{
                    width: "100%",
                    height: "350px",
                    objectFit: "fill",
                    borderRadius: "10px",
                  }}
                />

                <div className="card-body">
                  {/* <h5 className="card-title mt-3">{currentBlog.BLOG_TITLE}</h5> */}

                  <p dangerouslySetInnerHTML={{ __html: currentBlog.BLOG }}></p>

                  {/* {currentBlog.BLOG.length > 120 && (
                    <a href="#" className="btn btn-primary btn-animated">
                      View More
                    </a>
                  )} */}
                  {/* <p className="text-success text-right mt-2">
                    <span className="span-date bg-success text-white p-2 px-3">
                      {currentBlog.REG_DATE}
                    </span>
                  </p> */}
                </div>
              </div>
            </div>
          )}

          {/* Blog List Section */}
          <div
            className="col-lg-4 col-md-7 col-sm-12"
            style={{ padding: "0", margin: "0" }}
          >
            {/* Blog Cards */}
            <div className="row" style={{ padding: "0", margin: "0" }}>
              {filteredBlogs.map((data, index) => (
                <div
                  className="col-md-12 fade-in-up mb-3"
                  key={index}
                  style={{ padding: "0", margin: "0", cursor: "pointer" }}
                  onClick={() => {
                    setCurrentBlog(data);
                    navigate(`/spiritual-gyan/${data.Blog_Slug}`);
                  }}
                >
                  <div
                    className="card blog-card overflow-hidden card-shadow-sty rounded-3 border-1"
                    style={{ padding: "0", margin: "0" }}
                  >
                    <div
                      className="row g-0 "
                      style={{ padding: "0", margin: "0", justifyContent: 'left' }}
                    >
                      {/* <div
                        className="col-md-4 position-relative"
                        style={{ padding: "0", margin: "0" }}
                      >
                        <img
                          src={data.BLOG_IMAGE}
                          alt={data.BLOG_TITLE}
                          className="card-img blog-img object-fit-cover rounded-start"
                          height={"100%"}
                        />
                      </div> */}
                      <div className="col-md-12 d-flex flex-column  p-3">
                        <div >
                          {/* <span>Date: 14/03/2025</span> */}
                          <h5
                            className="card-title"
                            style={{
                              color: "black",
                              fontWeight: "500",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {data.BLOG_TITLE}
                          </h5>

                          <div className="d-flex justify-content-between ">

                            <p className="card-text  small   " style={{ fontSize: '11px' }}>
                              {/* {stripHtml(data.BLOG).length > 80
                              ? `${stripHtml(data.BLOG).substring(0, 80)}...`
                              : stripHtml(data.BLOG)} */}
                              {data.AutherName}
                            </p>
                            <p className="text-end mb-0 textDate-btn " style={{ fontSize: '11px' }}>
                              <span

                              >
                                <i className="icofont-ui-calendar mx-1" ></i>
                                {data.REG_DATE}
                              </span>
                            </p>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <MobileAppAd />
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default Blogs;
